import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import DOMPurify from 'dompurify';
import { isEmpty } from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { replaceAll } from '../utils/StringUtils';
import { checkForMediaLibraryLinkClicks } from '../utils/FileUtils';
import { injectMediaAuthToken } from '../utils/MediaAuthUtils';
import CaptureClicksV2 from '../../client/components/CaptureClicksV2';
import { PARTICIPANT_ROLES } from '../Constants';

class RichTextDisplay extends Component {
    static propTypes = {
        className: PropTypes.string,
        htmlToDisplay: PropTypes.any,
        currentUser: PropTypes.object,
        nextSectionName: PropTypes.string,
        employeeBeingAssessed: PropTypes.object,
        intl: PropTypes.object,
        idToken: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        // Inject authentication tokens into media URLs after initial render
        if (this.containerRef.current && this.props.idToken) {
            injectMediaAuthToken(this.containerRef.current, this.props.idToken).catch((error) => {
                console.warn('Error injecting media auth tokens:', error);
            });
        }
    }

    componentDidUpdate() {
        // Re-inject authentication tokens when content changes
        if (this.containerRef.current && this.props.idToken) {
            injectMediaAuthToken(this.containerRef.current, this.props.idToken).catch((error) => {
                console.warn('Error injecting media auth tokens:', error);
            });
        }
    }

    render() {
        const {
            intl,
            className,
            htmlToDisplay = '',
            nextSectionName = '',
            currentUser = {},
            employeeBeingAssessed = {},
        } = this.props;

        let htmlToRender = htmlToDisplay;

        const employeeFullNameDisplay = `${employeeBeingAssessed.firstName || ''} ${
            employeeBeingAssessed.lastName || ''
        }`;
        if (!isEmpty(currentUser) || !isEmpty(employeeBeingAssessed)) {
            let params = {
                '{{firstName}}':
                    currentUser.firstName ||
                    intl.formatMessage({ id: 'WORKSPACE_RICHTEXT_THERE', defaultMessage: 'there' }),
                '{{lastName}}': currentUser.lastName || '',
                '{{nextSection}}':
                    nextSectionName ||
                    intl.formatMessage({ id: 'FEEDBACK_NEXT_SECTION', defaultMessage: 'the next section' }),
                '{{employee}}': 'employees',
                '{{entrepreneur}}': 'entrepreneurs',
                '{{employeeFirstName}}': employeeBeingAssessed.firstName || '',
                '{{employeeFullName}}': employeeFullNameDisplay
            };

            htmlToRender = replaceAll(htmlToRender, params, { caseSensitive: true });
        }

        // TODO: We may need to use the FroalaEditorViewModcurrentElement component to render HTML when we get deeper into using Froala.
        return (
            <CaptureClicksV2 interruptingClickHandler={checkForMediaLibraryLinkClicks()}>
                <div
                    ref={this.containerRef}
                    className={cns(className)}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlToRender, { ADD_ATTR: ['target'] }) }}
                />
            </CaptureClicksV2>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        auth: { idToken }
    } = state;

    return {
        idToken
    };
};

export const RichTextDisplayComponent = RichTextDisplay;
export default connect(mapStateToProps)(injectIntl(RichTextDisplay));
